/**
 * ML-KEM and ML-DSA are named by parameter set (ML-KEM-768, ML-DSA-65), and imports carry that number
 * in key_length. It is not a key length in bits, so it is shown as the parameter set (C-030).
 */
const PQC_PARAMETER_SETS: Record<string, readonly number[]> = { 'ML-KEM': [512, 768, 1024], 'ML-DSA': [44, 65, 87] };
export function pqcParameterSet(algorithm: string | null | undefined, keyLength: number | null | undefined): string | null {
  if (!algorithm || keyLength == null) return null;
  const family = algorithm.trim().toUpperCase();
  const sets = PQC_PARAMETER_SETS[family];
  return sets && sets.includes(Number(keyLength)) ? `${family}-${keyLength}` : null;
}
